(() => {
  const init = () => {
    const root = document.querySelector('[data-ss27-catalogue]');
    if (!root) return;

    root.classList.add('ss27c-ready');

    const revealItems = [...root.querySelectorAll('[data-reveal], .ss27c-basket__row')];
    const reveal = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => reveal.observe(item));

    const links = new Map(
      [...root.querySelectorAll('[data-family-link]')].map((link) => [link.dataset.familyLink, link])
    );
    const families = [...root.querySelectorAll('.ss27c-family[id]')];
    const markCurrent = (id) => {
      links.forEach((link, key) => {
        if (key === id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const trackFamily = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) markCurrent(visible.target.id);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: [0.01, 0.15, 0.4] });
    families.forEach((family) => trackFamily.observe(family));

    const scrollToRequestedFamily = () => {
      const queryFamily = new URLSearchParams(window.location.search).get('family');
      const hashFamily = decodeURIComponent(window.location.hash.slice(1));
      const requestedFamily = queryFamily || hashFamily;
      const directTarget = requestedFamily && document.getElementById(requestedFamily);
      if (!directTarget) return;
      if (links.has(requestedFamily)) markCurrent(requestedFamily);
      requestAnimationFrame(() => directTarget.scrollIntoView({ block: 'start', behavior: 'instant' }));
      window.setTimeout(() => directTarget.scrollIntoView({ block: 'start', behavior: 'instant' }), 250);
    };
    scrollToRequestedFamily();
    window.addEventListener('hashchange', scrollToRequestedFamily);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
